import novaCruiser from "@/assets/vehicle-nova-cruiser.png";
import meridianTouring from "@/assets/vehicle-meridian-touring.png";
import apexTerrain from "@/assets/vehicle-apex-terrain.png";
import zenithPhantom from "@/assets/vehicle-zenith-phantom.png";
import ironcladHauler from "@/assets/vehicle-ironclad-hauler.png";

const vehicleImages: Record<string, string> = {
  starter: novaCruiser,
  sedan: meridianTouring,
  suv: apexTerrain,
  luxury: zenithPhantom,
  utility: ironcladHauler,
};

export default vehicleImages;
